module.exports = __webpack_public_path__ + "static/media/hinted-Whitney-Book.8d7bce42.woff";